// ListActions.jsx
import * as React from 'react';

import BulkSendSmsButton from "./bulk-action-button";
import {
    TopToolbar,
    FilterButton,
    ExportButton,
    CreateButton,
    useListContext,
    usePermissions
} from 'react-admin';


const ListActions = ({ filters }) => {
    const {
      displayedFilters,
      filterValues,
      showFilter,
      resource,
    } = useListContext();
    const { permissions } = usePermissions();
    const canEdit = permissions === "admin" || permissions === "operater";
    const filterArray = React.Children.toArray(filters({}).props.children);

  
    return (
      canEdit?  <TopToolbar>
        {filterArray.length > 0 && (
          <FilterButton
            filters={filterArray}
            displayedFilters={displayedFilters}
            filterValues={filterValues}
            showFilter={showFilter}
            resource={resource}
          />
        )}
         <CreateButton/>
        <ExportButton />
      <BulkSendSmsButton />
      </TopToolbar>:
     <TopToolbar>
        {filterArray.length > 0 && (
          <FilterButton
            filters={filterArray}
            displayedFilters={displayedFilters}
            filterValues={filterValues}
            showFilter={showFilter}
            resource={resource}
          />
        )}   
        <ExportButton />
      
      </TopToolbar>
    );
  };
  
  export default ListActions;
  